import React, { FunctionComponent, useRef, useState } from 'react';
import { Popover } from '@material-ui/core';
import { ExclamationIcon } from 'app/assets/images/icons';
import styles from './PopperComponent.module.scss';

interface Props {
  children: any;
  icon?: JSX.Element;
  compId?: string;
  noMargin?: boolean;
  noPadding?: boolean;
  style?:any
}
const PopperComponent: FunctionComponent<Props> = React.forwardRef(
  ({ children, icon, compId, noMargin, noPadding,style }, ref) => {
    const [openedPopover, setOpenedPopover] = useState(false);
    const popoverAnchor = useRef(null);

    const popoverEnter = () => {
      setOpenedPopover(true);
    };

    const popoverLeave = () => {
      setOpenedPopover(false);
    };
    return (
      <div
        className={styles.PopperComponent}
        data-testid="PopperComponent-testid"
        style={style}
      >
        <span
          data-testid="icon-popper-p"
          ref={popoverAnchor}
          aria-owns="mouse-over-popover"
          aria-haspopup="true"
          onMouseEnter={popoverEnter}
          onMouseLeave={popoverLeave}
          id={compId}
        >
          {icon ? icon : <ExclamationIcon />}
        </span>
        <Popover
          id="mouse-over-popover"
          data-testid="mouse-over-popover-comp"
          className={styles.popover}
          classes={{
            paper: styles.popoverContent,
          }}
          disableRestoreFocus
          open={openedPopover}
          anchorEl={popoverAnchor.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          PaperProps={{
            onMouseEnter: popoverEnter,
            onMouseLeave: popoverLeave,
          }}
          ref={ref}
        >
          <div
            className={`${styles.Popper} ${noMargin ? styles.noMargin : ''} ${noPadding ? styles.noPadding : ''}`}
          >
            {children}
          </div>
        </Popover>
      </div>
    );
  },
);

export default PopperComponent;
